import { useEffect } from 'react';
import styled from 'styled-components';

import { WhiteWrapper } from './WhiteWrapper';

const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSize.h1};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.brandPrimaryDark};
`;

const Text = styled.p`
  color: ${({ theme }) => theme.colors.brandPrimaryDark};
  font-size: ${({ theme }) => theme.fontSize.medium};
`;

interface MessageSentProps {
  onClose: () => void;
}

export const MessageSent: React.FC<MessageSentProps> = ({ onClose }) => {
  useEffect(() => {
    const timeout = setTimeout(onClose, 2000);

    return () => clearTimeout(timeout);
  }, [onClose]);

  return (
    <WhiteWrapper>
      <Title>Message Sent!</Title>
      <Text>{'Your message has been successfully sent. Thanks!'}</Text>
    </WhiteWrapper>
  );
};
